export function range(start: number, end?: number): Array<number>;
export function range(start: number, end: number): Array<number>;
export function range(
  start: number,
  end?: number,
  step?: number
): Array<number> {
  const _end = end || start;
  const _start = end ? start : 0;
  const _step = step || 1;
  return Array((_end - _start) / _step)
    .fill(0)
    .map((v, i) => _start + i * _step);
}



// WEBPACK FOOTER //
// ./src/range.ts